'use client';

import { Grid, InnerGrid } from 'app/shop-ui/section/Grid';
import { ELEMENT_TYPE } from 'shop-ui/constants';
import {
    RichText,
    Button,
    Media,
    Divider,
    ProductImageGallery,
    ProductInfoGroup,
    ProductPromoInfo,
    ProductGiveaway,
    ProductDescription,
    ProductShippingDetail,
    Carousel,
    Menu,
    SearchBar,
    FooterKYC,
    Copyright,
    Breadcrumb,
    Logo,
    ProductGroup,
    ProductSuggestion,
    HeaderCartIcon,
    HeaderLoginIcon,
} from 'shop-ui/component';

export const renderUIMap = {
    [ELEMENT_TYPE.GRID_PRIMARY_LEVEL]: Grid,
    [ELEMENT_TYPE.GRID_SECONDARY_LEVEL]: Grid,
    [ELEMENT_TYPE.GRID_SECONDARY_LEVEL_INNER]: InnerGrid,
    [ELEMENT_TYPE.BREADCRUMB]: Breadcrumb,
    [ELEMENT_TYPE.RICH_TEXT]: RichText,
    [ELEMENT_TYPE.COPYRIGHT]: Copyright,
    [ELEMENT_TYPE.BUTTON]: Button,
    [ELEMENT_TYPE.IMAGE]: Media,
    [ELEMENT_TYPE.VIDEO]: Media,
    [ELEMENT_TYPE.DIVIDER]: Divider,
    [ELEMENT_TYPE.CAROUSEL]: Carousel,
    [ELEMENT_TYPE.PRODUCT_IMAGE_GALLERY]: ProductImageGallery,
    [ELEMENT_TYPE.PRODUCT_INFO_GROUP]: ProductInfoGroup,
    [ELEMENT_TYPE.PRODUCT_PROMO_INFO]: ProductPromoInfo,
    [ELEMENT_TYPE.PRODUCT_GIVEAWAY]: ProductGiveaway,
    [ELEMENT_TYPE.PRODUCT_DESCRIPTION]: ProductDescription,
    [ELEMENT_TYPE.PRODUCT_SHIPPING_DETAIL]: ProductShippingDetail,
    [ELEMENT_TYPE.SEARCH_BAR]: SearchBar,
    [ELEMENT_TYPE.LOGO]: Logo,
    [ELEMENT_TYPE.MENU]: Menu,
    [ELEMENT_TYPE.HEADER_CART_ICON]: HeaderCartIcon,
    [ELEMENT_TYPE.HEADER_LOGIN_ICON]: HeaderLoginIcon,
    [ELEMENT_TYPE.FOOTER_KYC_AREA]: FooterKYC,
    [ELEMENT_TYPE.PRODUCT_GROUP]: ProductGroup,
    [ELEMENT_TYPE.PRODUCT_SUGGESTION]: ProductSuggestion,
};
